import { render, staticRenderFns } from "./biBarH.vue?vue&type=template&id=46f87666&"
import script from "./biBarH.vue?vue&type=script&lang=js&"
export * from "./biBarH.vue?vue&type=script&lang=js&"
import style0 from "./biBarH.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports